export default __webpack_public_path__ + "static/char-sp01-c7f394c81920beb526073c260f2ad481.gif";